import React from 'react';

const markup = String.raw`<div class="card">
<div class="card-head"><p class="card-title">My purchase order status</p><span class="click-tag">Click a slice ↓</span></div>
<div class="chart-wrap inline-style-13"><canvas aria-label="Donut chart of this vendor's purchase order status across completed, pending, in transit and cancelled, clickable to filter the orders table" id="vendPOStatus" role="img"></canvas></div>
<div class="legend-row inline-style-14"><span><span class="sw inline-style-15"></span>Completed</span><span><span class="sw inline-style-16"></span>Pending</span><span><span class="sw inline-style-10"></span>In transit</span><span><span class="sw inline-style-17"></span>Cancelled</span></div>
</div>`;

export default function POStatusCard() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
